<template>
    <div class="logos">
        <div class="content">
            <h2 class="title">Empresas já atendidas</h2>
            <div class="logo-column">
                <img :key="index" v-for="(logo, index) in logos" :src="logo" class="logo" />
            </div>
            <div class="category-text" v-html="slugInfo.categoryText" v-if="slugInfo.categoryText"></div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api';
export default {
    props: {
        slugInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    setup() {
        const self = reactive({
            logos: [
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Leroy Merlin.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Fundação Bradesco.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Lowndes.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Shopping Nova América.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/CIPA.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Renner.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Estácio.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Multiplan.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Papelex.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Icatu.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Alphaville.svg`,
                `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/Marriott.svg`,
            ],
        });

        return { ...toRefs(self) };
    },
};
</script>

<style lang="scss" scoped>
.logos {
    @apply py-8 md:py-8 lg:py-16;
    background-color: white;
    .content {
        @apply container mx-auto px-8;
        .title {
            @apply text-center font-bold mb-8 lg:mb-16;
            font-size: 36px;
            line-height: 36px;
            color: #0f2d53;
            // tablet
            @media screen and (max-width: 1024px) {
                font-size: 28px;
            }
            // mobile
            @media screen and (max-width: 767px) {
                font-size: 20px;
            }
        }
        .logo-column {
            @apply flex flex-wrap justify-between;
            .logo {
                @apply mr-8 mb-8;
                flex-grow: 1;
                width: 14%;
                height: 80px;
                border: 1px solid #dbdbdb;
                border-radius: 5px;
                // ultimo de cada linha
                &:nth-child(6),
                &:nth-child(12) {
                    @apply mr-0;
                }
                @media screen and (max-width: 1280px) {
                    @apply mr-5 mb-5;
                    width: 14%;
                    height: 53px;
                    // ultimo de cada linha
                    &:nth-child(6),
                    &:nth-child(12) {
                        @apply mr-0;
                    }
                }
                // mobile
                @media screen and (max-width: 767px) {
                    @apply mr-5 mb-5;
                    width: 42%;
                    height: 60px;
                    // ultimo de cada linha
                    &:nth-child(even) {
                        @apply mr-0;
                    }
                }
            }
        }
        .category-text {
            @apply w-full md:w-8/12 mx-auto mt-8;
            white-space: pre-line;
        }
    }
}
</style>
